// Parâmetros de identificação exigidos pela API do histórico. Extraímos apenas
// esta allowlist da query string da página (o backend lê partnerId/patientCode/
// doctorCode no corpo do POST) para não repassar params arbitrários da URL.
const HISTORY_PARAM_KEYS = ["partnerId", "patientCode", "doctorCode"];

const getHistoryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return HISTORY_PARAM_KEYS.reduce((params, key) => {
    const value = searchParams.get(key);

    if (value !== null) {
      params[key] = value;
    }

    return params;
  }, {});
};

export default getHistoryParams;
